export enum EnumPartnerSegment {
  BPO = "BPO",
  ACCOUNTING = "Contabilidade",
  INSURANCE = "Corretora de Seguros",
  CONSULTANCY = "Consultoria",
  FINANCIAL_SERVICES = "Serviços financeiros",
  HR_SOLUTIONS = "Soluções para RH",
  OTHER = "Outro",
}
